interface LockIconProps {
  size?: number;
  className?: string;
}

export const LockIcon = ({ size = 48, className = '' }: LockIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        {/* Gradient for 3D effect on body */}
        <linearGradient id="lockBodyGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FFE500" />
          <stop offset="50%" stopColor="#FFA500" />
          <stop offset="100%" stopColor="#FF8C00" />
        </linearGradient>

        {/* Gradient for shackle */}
        <linearGradient id="lockShackleGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#C0C0C0" />
          <stop offset="50%" stopColor="#E8E8E8" />
          <stop offset="100%" stopColor="#A8A8A8" />
        </linearGradient>

        {/* Shadow filter */}
        <filter id="lockShadow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="0.5" />
          <feOffset dx="0" dy="2" result="offsetblur" />
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.4" />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Lock Shadow */}
      <rect
        x="5.5"
        y="11.5"
        width="13"
        height="9.5"
        rx="2"
        fill="rgba(0, 0, 0, 0.3)"
      />

      {/* Lock Body - Main */}
      <rect
        x="5"
        y="11"
        width="14"
        height="10"
        rx="2"
        fill="url(#lockBodyGradient)"
        stroke="#8B4513"
        strokeWidth="1.2"
        filter="url(#lockShadow)"
      />

      {/* Lock Body - Highlight */}
      <rect
        x="6"
        y="12"
        width="4"
        height="3"
        rx="1"
        fill="rgba(255, 255, 255, 0.4)"
      />

      {/* Lock Body - Bottom edge for depth */}
      <rect
        x="5"
        y="19"
        width="14"
        height="2"
        rx="1"
        fill="rgba(0, 0, 0, 0.2)"
      />

      {/* Lock Shackle - Background (shadow) */}
      <path
        d="M8.5 11.5V7.5C8.5 5.29086 10.2909 3.5 12.5 3.5C14.7091 3.5 16.5 5.29086 16.5 7.5V11.5"
        stroke="rgba(0, 0, 0, 0.3)"
        strokeWidth="3"
        strokeLinecap="round"
      />

      {/* Lock Shackle - Main */}
      <path
        d="M8 11V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V11"
        stroke="url(#lockShackleGradient)"
        strokeWidth="2.5"
        strokeLinecap="round"
        filter="url(#lockShadow)"
      />

      {/* Lock Shackle - Inner highlight */}
      <path
        d="M9 11V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7V11"
        stroke="rgba(255, 255, 255, 0.5)"
        strokeWidth="1"
        strokeLinecap="round"
      />

      {/* Keyhole - Shadow */}
      <circle cx="12.3" cy="15.3" r="1.5" fill="rgba(0, 0, 0, 0.4)" />
      <rect
        x="11.3"
        y="16.3"
        width="2"
        height="3"
        rx="1"
        fill="rgba(0, 0, 0, 0.4)"
      />

      {/* Keyhole - Main */}
      <circle cx="12" cy="15" r="1.5" fill="#2E4056" />
      <rect x="11" y="16" width="2" height="3" rx="1" fill="#2E4056" />
    </svg>
  );
};
